import { render, staticRenderFns } from "./SuccessText.vue?vue&type=template&id=6f1cbdf2&scoped=true&functional=true"
import script from "./SuccessText.vue?vue&type=script&lang=js"
export * from "./SuccessText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6f1cbdf2",
  null
  
)

export default component.exports